import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getThemeAndColor } from '../utils/getThemeAndColor'
import { getClientCustomFetch } from '../lib/getClientCustomFetch'

export const fetchThemesData = createAsyncThunk(
  'themeName/fetchThemesData',
  async (_, { rejectWithValue }) => {
    const customFetch = await getClientCustomFetch()
    try {
      const response = await customFetch.get('/organization')
      const organizationDataResp = response?.data?.data
      const themesAndColor = await getThemeAndColor(organizationDataResp)
      return themesAndColor
    } catch (error) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch theme data'
      )
    }
  }
)

const initialState = {
  currentTheme: null,
  websiteTheme: null,
  loading: false,
  error: null,
}

const themeNameSlice = createSlice({
  name: 'themeName',
  initialState,
  reducers: {
    setThemesData: (state, action) => {
      state.currentTheme = action.payload.currentTheme
      state.websiteTheme = action.payload.websiteTheme
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchThemesData.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchThemesData.fulfilled, (state, action) => {
        state.loading = false
        state.currentTheme = action.payload.currentTheme
        state.websiteTheme = action.payload.websiteTheme
      })
      .addCase(fetchThemesData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { setThemesData } = themeNameSlice.actions
export default themeNameSlice.reducer
